require('./brokerStocksSaleOrderView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const BrokerStocksSaleOrderWizard = require('components/broker/brokerStocksSaleOrder/brokerStocksSaleOrderWizard');
const BrokerStocksSaleOrderSuccess = require('components/broker/brokerStocksSaleOrder/brokerStocksSaleOrderSuccess/brokerStocksSaleOrderSuccess');
const BrokerStocksSaleOrderSidebar = require('components/broker/brokerStocksSaleOrder/brokerStocksSaleOrderSidebar/brokerStocksSaleOrderSidebar');

// @helpers
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const { getDocumentURL } = require('utilities/stringHelper');

// @actions
const BrokerStocksSaleOrderActions = require('actions/brokerStocksSaleOrder');
const productFileActions = require('actions/brokerGetProductFile');

//@constants
const {
    MYPROFILE_BROKER_URL,
    BROKER_CORPORATE_OPERATIONS_URL,
    BROKER_SELL_SCREEN
} = require('constants/index');

class BrokerStocksSaleOrderView extends React.Component {

    componentWillMount() {
        const { immBrokerStocksSaleOrder, getProductFile, history } = this.props;
        const immOperation = immBrokerStocksSaleOrder.get('operation');
        const isLoaded = immBrokerStocksSaleOrder.get('isLoaded');

        if (!isLoaded) {
            history.push(BROKER_CORPORATE_OPERATIONS_URL);
        } else if (immOperation) {
            const isin = immOperation.get('isin');
            const iso = immOperation.get('iso');
            getProductFile(isin, iso, BROKER_SELL_SCREEN);
        }
    }

    buildSideColumn() {
        const { immBrokerStocksSaleOrder } = this.props;

        return (
            <BrokerStocksSaleOrderSidebar
                immBrokerStocksSaleOrder={immBrokerStocksSaleOrder}
            />
        );
    }

    buildSuccess() {
        const { immBrokerStocksSaleOrder } = this.props;

        return (
            <BrokerStocksSaleOrderSuccess
                immBrokerStocksSaleOrder={immBrokerStocksSaleOrder}
            />
        );
    }

    buildWizard() {
        const {
            immBrokerStocksSaleOrder,
            immCorporatesOperations,
            immSignaturePattern,
            onChangeTitlesAmount,
            onValidateStep,
            onSetVisibleStep,
            onChangeManifest,
            onFinish,
            setDocumentsRead
        } = this.props;

        return (
            <BrokerStocksSaleOrderWizard
                immBrokerStocksSaleOrder={immBrokerStocksSaleOrder}
                immSignaturePattern={immSignaturePattern}
                immCorporatesOperations={immCorporatesOperations}
                onChangeTitlesAmount={onChangeTitlesAmount}
                onValidateStep={onValidateStep}
                onSetVisibleStep={onSetVisibleStep}
                onChangeManifest={onChangeManifest}
                onFinish={onFinish}
                setDocumentsRead={setDocumentsRead}
            />
        );
    }

    render() {
        const { immBrokerStocksSaleOrder, immVariables } = this.props;
        const breadcrumb = [
            {
                text: formatText('broker-myWallet'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('stocksSaleOrder-corporateOperations'),
                url: '/myprofile/broker/corporatesOperations'
            },
            {
                text: formatText('stocksSaleOrder-opaStocksSale'),
                url: ''
            }
        ];
        const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));
        let content;

        if (immBrokerStocksSaleOrder.get('finished')) {
            content = this.buildSuccess();
        } else {
            content = (
                <div className="row no-outside-gutter">
                    <div className="col-xs-8">
                        {this.buildWizard()}
                    </div>

                    <div className="col-xs-4">
                        {this.buildSideColumn()}
                    </div>
                </div>
            );
        }

        return (
            <section className="broker-stocks-sale-order-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        subtitleLeft={formatText('stocksSaleOrder-subtitle')}
                        isSubtitleLeftCapital={false}
                        finalTitle={getFinalTitle('stocksSaleOrder-title')}
                    >
                        <OKButton
                            modifier="primary"
                            to={fees_url}
                        >
                            <FormattedText
                                value="requestFinancialOperationChange-commissions"
                            />
                        </OKButton>
                    </OKHeaderSubPage>
                </OKCover>
                <section className="broker-stocks-sale-order-view__body">
                    {content}
                </section>
            </section>
        );
    }
}

BrokerStocksSaleOrderView.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerStocksSaleOrder: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    onChangeTitlesAmount: PropTypes.func.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onSetVisibleStep: PropTypes.func.isRequired,
    onChangeManifest: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    getProductFile: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired
};

module.exports.constructor = BrokerStocksSaleOrderView;
module.exports.BrokerStocksSaleOrderView = connect(
    (state) => ({
        immBrokerStocksSaleOrder: state.brokerStocksSaleOrder,
        immCorporatesOperations: state.brokerCorporatesOperations,
        immSignaturePattern: state.signaturePattern,
        immVariables: state.globalVariables
    }),
    {
        onChangeTitlesAmount: BrokerStocksSaleOrderActions.changeTitlesAmount,
        onValidateStep: BrokerStocksSaleOrderActions.validateStep,
        onSetVisibleStep: BrokerStocksSaleOrderActions.setStep,
        onChangeManifest: BrokerStocksSaleOrderActions.changeManifest,
        onFinish: BrokerStocksSaleOrderActions.finish,
        onStocksSaleOrder: BrokerStocksSaleOrderActions.start,
        getProductFile: productFileActions.getProductFile,
        setDocumentsRead: BrokerStocksSaleOrderActions.setDocumentsRead
    }
)(withRouter(BrokerStocksSaleOrderView));
